/**
 * AB TEST 'Carrusel' — Añadir al carrito
 *
 * El botón negro (#atcCarrusel) es solo presentación: delega el add-to-cart en el
 * quick-buy NATIVO del theme, que ya vive en la misma card (.product-card__quick-buy)
 * y está oculto por CSS.
 *
 * Dos caminos, según el producto:
 *   - 1 variante y sin selling plans -> la card trae un <form is="product-form">.
 *     Se hace requestSubmit() y el theme añade al carrito por AJAX.
 *   - varias variantes -> la card trae un <button aria-controls="quick-buy-...">
 *     que abre el <quick-buy-drawer> para que el cliente elija variante.
 *
 * Requiere que la sección renderice la card con show_quick_buy: true.
 */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('#atcCarrusel');
  if (!trigger) return;

  const card = trigger.closest('product-card, .ab-carrusel-card, .product-card');
  if (!card) return;

  const quickBuy = card.querySelector('.product-card__quick-buy');
  if (!quickBuy) {
    console.warn('[AB Carrusel] No hay quick-buy nativo en la card. ¿Falta show_quick_buy: true en la sección?');
    return;
  }

  // Producto de una sola variante: submit real del formulario del theme.
  const form = quickBuy.querySelector('form');
  if (form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    return;
  }

  // Producto con variantes: abrir el drawer de selección.
  const drawerTrigger = quickBuy.querySelector('button[aria-controls]');
  if (drawerTrigger) {
    drawerTrigger.click();
    return;
  }

  console.warn('[AB Carrusel] Quick-buy presente pero sin form ni trigger de drawer.');
});
